import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiOperation } from './api-discoverability.service';

export interface ApiMeshState {
  selectedOperation: ApiOperation | null;
  showDynamicViewer: boolean;
  explorerState?: {
    searchTerm: string;
    filteredOperations: ApiOperation[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class ApiMeshStateService {
  private stateSubject = new BehaviorSubject<ApiMeshState>({
    selectedOperation: null,
    showDynamicViewer: false
  });

  public state$ = this.stateSubject.asObservable();

  constructor() { }

  openDynamicViewer(operation: ApiOperation, explorerState?: any): void {
    this.stateSubject.next({
      selectedOperation: operation,
      showDynamicViewer: true,
      explorerState: explorerState
    });
  }

  closeDynamicViewer(): void {
    const currentState = this.stateSubject.value;
    this.stateSubject.next({
      ...currentState,
      selectedOperation: null,
      showDynamicViewer: false
    });
  }

  updateExplorerState(explorerState: any): void {
    const currentState = this.stateSubject.value;
    this.stateSubject.next({
      ...currentState,
      explorerState: explorerState
    });
  }

  getCurrentState(): ApiMeshState {
    return this.stateSubject.value;
  }
}